import React, { useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { getBatchAthletes, getCoachesList } from '../../../services/adminApiService/batchManagementApi/BatchManagementApiService';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import TextMasked from '../../../utils/TextMasked';

const SportDetail = () => {
    const { sportId } = useParams();
    const [activeTab, setActiveTab] = useState('athletes');

    const [athletes, setAthletes] = useState([]);
    const [athletesTotalPages, setAthletesTotalPages] = useState(1);
    const [athletesPage, setAthletesPage] = useState(1);
    const [athletesPerPage, setAthletesPerPage] = useState(10);
    const [athletesLoading, setAthletesLoading] = useState(false);

    const [coaches, setCoaches] = useState([]);
    const [coachesTotalPages, setCoachesTotalPages] = useState(1);
    const [coachesPage, setCoachesPage] = useState(1);
    const [coachesPerPage, setCoachesPerPage] = useState(10);
    const [coachesLoading, setCoachesLoading] = useState(false);

    useEffect(() => {
        if (activeTab !== 'athletes') return;
        const fetchAthletes = async () => {
            setAthletesLoading(true);
            try {
                const response = await getBatchAthletes({ sport_id: sportId, per_page: athletesPerPage, page: athletesPage });
                setAthletes(response?.data?.data || []);
                setAthletesTotalPages(response?.data?.pagination?.last_page || 1);
            } catch (error) {
                console.error('Sport athletes error:', error);
            } finally {
                setAthletesLoading(false);
            }
        };
        fetchAthletes();
    }, [activeTab, sportId, athletesPerPage, athletesPage]);

    useEffect(() => {
        if (activeTab !== 'coaches') return;
        const fetchCoaches = async () => {
            setCoachesLoading(true);
            try {
                const response = await getCoachesList({ sports_id: sportId, limit: coachesPerPage, page: coachesPage });
                setCoaches(response?.data?.data || []);
                setCoachesTotalPages(response?.data?.total_pages || 1);
            } catch (error) {
                console.error('Sport coaches error:', error);
            } finally {
                setCoachesLoading(false);
            }
        };
        fetchCoaches();
    }, [activeTab, sportId, coachesPerPage, coachesPage]);

    return (
        <>
            <PageTitle activeMenu="Sport Detail" motherMenu="All Sports" />
            <div className="col-12">
                <div className="card filter-card-wrapper">
                    <div className="px-3 pt-3 d-flex gap-2">
                        <Button variant={activeTab === 'athletes' ? 'primary' : 'outline-primary'} onClick={() => setActiveTab('athletes')}>Athletes</Button>
                        <Button variant={activeTab === 'coaches' ? 'primary' : 'outline-primary'} onClick={() => setActiveTab('coaches')}>Coaches</Button>
                    </div>

                    {activeTab === 'athletes' ? (
                        <>
                            <div className="px-3 d-flex mt-3 mx-2">
                                <FilterNumber value={athletesPerPage} onChange={(val) => { setAthletesPerPage(val); setAthletesPage(1); }} />
                            </div>
                            <div className="card-body">
                                {athletesLoading ? (
                                    <div className="text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-100 table-responsive">
                                        <table id="example" className="display w-100 dataTable">
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    <th>Unique Id</th>
                                                    <th>Name</th>
                                                    <th>Category</th>
                                                    <th>Contact Number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {athletes.length > 0 ? (
                                                    athletes.map((data, index) => {
                                                        const serialNumber = (athletesPage - 1) * athletesPerPage + (index + 1);
                                                        const fullName = [data?.first_name, data?.middle_name, data?.last_name].filter(Boolean).join(' ');
                                                        return (
                                                            <tr key={data.id}>
                                                                <td>{serialNumber}</td>
                                                                <td>{data?.atom_id}</td>
                                                                <td>{fullName}</td>
                                                                <td>{data?.user_type_name}</td>
                                                                <td><TextMasked value={data?.mobile} type="phone" /></td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">Data is not available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                            <ReactPaginate
                                nextLabel="next >"
                                onPageChange={(e) => setAthletesPage(e.selected + 1)}
                                pageRangeDisplayed={8}
                                marginPagesDisplayed={7}
                                pageCount={athletesTotalPages}
                                previousLabel="< previous"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination d-flex flex-wrap px-3 pb-3"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                                forcePage={athletesPage - 1}
                            />
                        </>
                    ) : (
                        <>
                            <div className="px-3 d-flex mt-3 mx-2">
                                <FilterNumber value={coachesPerPage} onChange={(val) => { setCoachesPerPage(val); setCoachesPage(1); }} />
                            </div>
                            <div className="card-body">
                                {coachesLoading ? (
                                    <div className="text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-100 table-responsive">
                                        <table id="example" className="display w-100 dataTable">
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Contact Number</th>
                                                    <th>District</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {coaches.length > 0 ? (
                                                    coaches.map((data, index) => {
                                                        const serialNumber = (coachesPage - 1) * coachesPerPage + (index + 1);
                                                        return (
                                                            <tr key={data.id}>
                                                                <td>{serialNumber}</td>
                                                                <td>{data?.name}</td>
                                                                <td><TextMasked value={data?.email} type="email" /></td>
                                                                <td><TextMasked value={data?.mobile} type="phone" /></td>
                                                                <td>{data?.district_name}</td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">Data is not available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                            <ReactPaginate
                                nextLabel="next >"
                                onPageChange={(e) => setCoachesPage(e.selected + 1)}
                                pageRangeDisplayed={8}
                                marginPagesDisplayed={7}
                                pageCount={coachesTotalPages}
                                previousLabel="< previous"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination d-flex flex-wrap px-3 pb-3"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                                forcePage={coachesPage - 1}
                            />
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export default SportDetail
